import React from 'react';
import { cpManagementRoute } from '@/modules/administration/charge-point-management/routes';
import { createRoute } from '@tanstack/react-router';

export const cpManagementStatusRoute = createRoute({
  getParentRoute: () => cpManagementRoute,
  path: 'status',
  wrapInSuspense: true,
  component: React.lazy(
    async () => await import('@/app/routes/Admin/AdminChargePoints/ChargePointsStatus')
  ),
});
